import React from "react";
import PopularSwiper from "./PopularSwiper";

const PopularShops = () => {
  return (
    <div>
      <div className="h-full lg:h-full -mt-10">
        <div className="mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
          <h2 className="text-2xl font-bold tracking-tight text-gray-900 sm:text-center md:text-left md:text-5xl">
            Shop popular items
          </h2>
          <p className="my-3 ">Our highest sold product of the week</p>
          <div className="mb-3">
            {" "}
            <PopularSwiper />
          </div>
          <div className="mb-3 hidden md:block">
            {" "}
            <PopularSwiper />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularShops;
